// extracted by mini-css-extract-plugin
module.exports = {"btnDiv":"Button_btnDiv__2gWmx","btntext":"Button_btntext__12hwJ"};